export const PATH_LOGOS = "https://imob86.concept.inf.br/logos/";

export const PATH_IMAGENS_SITE = "https://imob86.concept.inf.br/imagensSite/";

export const AREA_PESQUISA_IMOVEL = [
  { label: "Até 50m²", data: "50" },
  { label: "Entre 51m² e 100m²", data: 51 },
  { label: "Entre 101m² e 150m²", data: 101 },
  { label: "Entre 151m² e 200m²", data: 151 },
  { label: "Entre 201m² e 250m²", data: 201 },
  { label: "Entre 251m² e 300m²", data: 251 },
  { label: "Acima de 300m²", data: 300 }
]

export const ESTADOS = [
	{ sigla: "AC", id: 3, nome:"Acre" },
	{ sigla: "AL", id: 4, nome:"Alagoas" },
	{ sigla: "AM", id: 6, nome:"Amazonas" },
	{ sigla: "AP", id: 5, nome:"Amapá" },
	{ sigla: "BA", id: 7, nome:"Bahia" },
	{ sigla: "CE", id: 8, nome:"Ceará" },
	{ sigla: "DF", id: 9, nome:"Distrito Federal" },
	{ sigla: "ES", id: 10, nome:"Espírito Santo" },
	{ sigla: "GO", id: 11, nome:"Goiás" },
	{ sigla: "MA", id: 2, nome:"Maranhão" },
	{ sigla: "MG", id: 14, nome:"Minas Gerais" },
	{ sigla: "MS", id: 13, nome:"Mato Grosso do Sul" },
	{ sigla: "MT", id: 12, nome:"Mato Grosso" },
	{ sigla: "PA", id: 15, nome:"Pará" },
	{ sigla: "PB", id: 16, nome:"Paraíba" },
	{ sigla: "PE", id: 18, nome:"Pernambuco" },
	{ sigla: "PI", id: 1, nome:"Piauí" },
	{ sigla: "PR", id: 17, nome:"Paraná" },
	{ sigla: "RJ", id: 19, nome:"Rio de Janeiro" },
	{ sigla: "RN", id: 20, nome:"Rio Grande do Norte" },
	{ sigla: "RO", id: 22, nome:"Rondônia" },
	{ sigla: "RR", id: 23, nome:"Roraima" },
	{ sigla: "RS", id: 21, nome:"Rio Grande do Sul" },
	{ sigla: "SC", id: 24, nome:"Santa Catarina" },
	{ sigla: "SE", id: 26, nome:"Sergipe" },
	{ sigla: "SP", id: 25, nome:"São Paulo" },
	{ sigla: "TO", id: 27, nome:"Tocantins" }
]

export const TIPOS_IMOVEIS = [
	{ nome: "Apartamento", id: 1 },
	{ nome: "Casa Comercial", id: 2 },
	{ nome: "Casa em Condomínio", id: 3 },
	{ nome: "Casa Residencial", id: 4 },
	{ nome: "Fazenda", id: 17 },
	{ nome: "Flat/Apart Hotel", id: 5 },
	{ nome: "Galpão", id: 6 },
	{ nome: "Garagem/Estacionamento", id: 16 },
	{ nome: "Hotel/Motel", id: 15 },
	{ nome: "Lote em Condomínio", id: 12 },
	{ nome: "Loja Comercial", id: 19 },
	{ nome: "Loja/Sala Comercial", id: 7 },
	{ nome: "Lote/Terreno", id: 8 },
	{ nome: "Ponto Comercial", id: 11 },
	{ nome: "Prédio Comercial", id: 14 },
	{ nome: "Quiosque", id: 13 },
	{ nome: "Quitinete", id: 9 },
	{ nome: "Sala Comercial", id: 18 },
	{ nome: "Sítio/Chácara", id: 10 }
];

export const CATEGORIAS_VENDA = [
	{ label: "Imóvel Avulso", data: "IMOVEL_AVULSO" },
	{ label: "Lançamento", data: "LANCAMENTO" }
];

export const FILTROS_DASHBOARD = [
	{ label: "Com Foto", data: "IMOVEIS_COM_FOTO" },
	{ label: "Sem Foto", data: "IMOVEIS_SEM_FOTO" },
	{ label: "Captados - Mês Atual", data: "IMOVEIS_CAPTADOS" },
	{ label: "Vendidos - Mês Atual", data: "IMOVEIS_VENDIDOS" },
	{ label: "Com Localização", data: "IMOVEIS_COM_LOCALIZACAO" },
	{ label: "Sem Localização", data: "IMOVEIS_SEM_LOCALIZACAO" }
];

export const STATUS_VENDA = [
  { label: "Disponível", data: "DISPONIVEL" },
	{ label: "Indisponível", data: "INDISPONIVEL" },
  { label: "Vendido", data: "VENDIDO" },
  { label: "Reservado", data: "RESERVADO" },
	{ label: "Arquivado", data: "ARQUIVADO" }
];

export const STATUS_CONTRATO = [
  { label: "Pendente", data: "PENDENTE" },
  { label: "Aprovado", data: "APROVADO" },
  { label: "Cancelado", data: "CANCELADO" }
];

export const STATUS_CONTRATO_ALUGUEL = [
  { label: "Pendente", data: "PENDENTE" },
	{ label: "Aprovado", data: "APROVADO" },
	{ label: "Desocupação", data: "EM_DESOCUPACAO" },
	{ label: "Finalizado", data: "FINALIZADO" }
];

export const STATUS_IMOVEL_ALUGUEL = [
	{ label: "Disponível", data: "DISPONIVEL" },
	{ label: "Reservado", data: "RESERVADO" },
	{ label: "Indisponível", data: "INDISPONIVEL" },
	{ label: "Locado", data: "LOCADO" },
	{ label: "Em Desocupação", data: "EM_DESOCUPACAO" },
	{ label: "Arquivado", data: "ARQUIVADO" }
  ];

export const OPERACAO_IMOVEL = [
	{ label: "Aluguel", data: "ALUGUEL" },
	{ label: "Venda", data: "VENDA" }
]

export const POSSE_CHAVE = [
  { label: "Proprietário", data: "PROPRIETARIO" },
  { label: "Imobiliária", data: "IMOBILIARIA" },
  { label: "Outro", data: "OUTRO" }
]

export const AUTORIZACAO_VENDA = [
  { label: "Escrita", data: "ESCRITA" },
  { label: "Verbal", data: "VERBAL" }
]

export const AUTORIZACAO_PLACA = [
  { label: "Colocação de placa permitida pelo proprietário", data: "PERMITIDO" },
  { label: "Proprietário não permitiu colocar placa", data: "PROPRIETARIO_NAO_PERMITIU" },
  { label: "Não é possível colocar placa", data: "NAO_PODE_COLOCAR_PLACA" }
]

export const OCORRENCIA_RETIRADA_PLACA = [
  { label: "Placa Retirada", data: "RETIRADA" },
  { label: "Placa Extraviada", data: "EXTRAVIADA" }
]

export const DURACAO_RESERVA = [
	{label: "6 horas", data: "6"},
	{label: "12 horas", data: "12"},
	{label: "24 horas", data: "24"},
	{label: "36 horas", data: "36"},
	{label: "48 horas", data: "48"},
	{label: "10 dias", data: "240"},
	{label: "15 dias", data: "360"},
	{label: "30 dias", data: "720"}
]

export const DURACAO_PRORROGACAO = [
	{label: "6 horas", data: "6"},
	{label: "12 horas", data: "12"},
	{label: "1 dia", data: "24"},
	{label: "2 dias", data: "48"},
	{label: "5 dias", data: "120"},
	{label: "7 dias", data: "168"}
]

export const BANCOS_HOMOLOGADOS = [
	{label:"", data:""},
	{label:"Banco do Brasil", data:"BANCO_DO_BRASIL"},
	{label:"Bradesco", data:"BRADESCO"},
	{label:"Caixa Econômica", data:"CAIXA_ECONOMICA"},
	{label:"Itaú", data:"ITAU"},
	{label:"Santander", data:"SANTANDER"},
	{label:"SICOOB", data:"SICOOB"},
]

export const BANCOS_IMOBILIARIA = [
	{label:"", data:""},
	{label:"Banco do Brasil", data:"BANCO_DO_BRASIL"},
	{label:"Bradesco", data:"BRADESCO"},
	{label:"Caixa Econômica", data:"CAIXA_ECONOMICA"},
	{label:"Itaú", data:"ITAU"},
	{label:"Santander", data:"SANTANDER"},
	{label:"SICOOB", data:"SICOOB"},
	{label:"Banco do Nordeste", data:"BANCO_DO_NORDESTE"},
	{label:"Sicredi", data:"SICRED"},
]

export const BANCOS = [
	{label:"Bancoob", data:"BANCOOB"},
	{label:"Banco do Brasil", data:"BANCO_DO_BRASIL"},
	{label:"Banco do Nordeste", data:"BANCO_DO_NORDESTE"},
	{label:"Banco Mercantil", data:"BANCO_MERCANTIL"},
	{label:"Banco Original", data:"BANCO_ORIGINAL"},
	{label:"Banco Real", data:"BANCO_REAL"},
	{label:"Bradesco", data:"BRADESCO"},
	{label:"Caixa Econômica", data:"CAIXA_ECONOMICA"},
	{label:"Cora", data:"CORA"},
	{label:"Digio", data:"DIGIO"},
	{label:"HSBC", data:"HSBC"},
	{label:"Inter", data:"INTER"},
	{label:"Itaú", data:"ITAU"},
	{label:"Next", data:"NEXT"},
	{label:"Nubank", data:"NUBANK"},
	{label:"Pag Seguro", data:"PAG_SEGURO"},
	{label:"PicPay", data:"PICPAY"},
	{label:"Santander", data:"SANTANDER"},
	{label:"Sicoob", data:"SICOOB"},
	{label:"Sicredi", data:"SICRED"},
	{label:"Sudameris", data:"SUDAMERIS"},
	{label:"Votorantim", data:"VOTORANTIM"},
	{label:"Wirecard", data:"WIRECARD"},
	{label:"XP Investimentos", data:"XP_INVESTIMENTOS"},
	
]

export const STATUS_CONTA = [
	{ label: "Ativo", data: "ATIVO" },
	{ label: "Inativo", data: "INATIVO" }
]

export const STATUS_LANCAMENTO = [
	{label:"Aberto", data:"ABERTO"},
	{label:"Efetuado", data:"EFETUADO"},
	{label:"Cancelado", data:"CANCELADO"},
	{label:"Devolvido", data:"DEVOLVIDO"}
];

export const TIPO_LANCAMENTO = [
	{label:"Boleto", data:"BOLETO"},
	{label:"Cheque", data:"CHEQUE"},
	{label:"Cartão de Crédito", data:"CARTAO_CREDITO"},
	{label:"Cartão de Débito", data:"CARTAO_DEBITO"},
	{label:"Débito em Conta", data:"DEBITO_CONTA"},
	{label:"Deposito em Conta", data:"DEPOSITO_CONTA"},
	{label:"Dinheiro", data:"DINHEIRO"},
	{label:"Não Informado", data: "NAO_INFORMADO"}
];

export const STATUS_CONTA_RECEBER_PAGAR = [
	{label:"Provisória", data:"PROVISORIA"},
	{label:"Aberta", data:"ABERTA"},
	{label:"Paga", data:"PAGA"},
	{label:"Cancelada", data:"CANCELADA"}
]

export const STATUS_LISTA_ESPERA_PRETENDENTES = [
	{ label: "Em Espera", data: "EM_ESPERA" },
	{ label: "Concluído", data: "CONCLUIDO" },
	{ label: "Cancelado", data: "CANCELADO" }
]

export const TIPO_CONTA = [
	{label: "Conta Corrente", data: "CONTA_CORRENTE"},
	{label: "Conta Poupança", data: "CONTA_POUPANCA"}
]

export const STATUS_CONTATO = [
	{label: "Em Andamento", data: "EM_ANDAMENTO"}, 
	{label: "Concluído", data: "CONCLUIDO"}
]

export const STATUS_PAGAMENTO = [
	{label: "Pago", data: "PAGO"}, 
	{label: "Em Aberto", data: "EM_ABERTO"},
	{label: "Cancelado", data: "CANCELADO"}
]

export const ESTADO_CIVIL = [
	{label: "Solteiro", data: "SOLTEIRO"},
	{label: "Casado", data: "CASADO"},
	{label: "Divorciado", data: "DIVORCIADO"},
	{label: "Viúvo", data: "VIUVO"},
	{label: "União Estável", data: "UNIAO_ESTAVEL"}
]

export const TIPOS_CONTATOS = [
	{ label: "Residencial", data: "RESIDENCIAL" },
	{ label: "Comercial", data: "COMERCIAL" }
]

export const TIPO_LOCACAO = [
	{ label: "Residencial", data: "RESIDENCIAL" },
	{ label: "Comercial", data: "COMERCIAL" }
]

export const TIPO_ALUGUEL = [
	{ label: "Garantido", data: "GARANTIDO" },
	{ label: "Não Garantido", data: "NAO_GARANTIDO" }
]

export const CATEGORIA_CLIENTE = [
	{ label: "Proprietários/Compradores", data: "PROPRIETARIO_COMPRADOR" },
	{ label: "Proprietários", data: "PROPRIETARIO" },
	{ label: "Compradores", data: "COMPRADOR" },
	{ label: "Pretendentes", data: "PRETENDENTE" }
]

export const PERFIL_CLIENTE_ALUGUEL = [
	{label: "Proprietários/Locatários", data: "PROPRIETARIO_LOCATARIO"},
	{label: "Proprietários", data: "PROPRIETARIO"},
	{label: "Beneficiários", data: "BENEFICIARIO"},
	{label: "Locatários", data: "LOCATARIO"},
	{label: "Fiadores", data: "FIADOR"},
	{label: "Pretendentes", data: "PRETENDENTE"}
]

export const TIPOS_RELATORIO_COMISSOES = [
	{ label: "Relatório de Comissoes a Pagar", data: "COMISSOES_A_PAGAR" },
	{ label: "Relatório de Comissoes Pagas", data: "COMISSOES_PAGAS" }
]

export const TIPOS_MIDIA = [
	{ label: "TV", data: "TV" },
	{ label: "Panfletos", data: "PANFLETOS" },
	{ label: "Outdoor", data: "OUTDOOR" },
	{ label: "Indicação", data: "INDICACAO" },
	{ label: "Internet", data: "INTERNET" },
	{ label: "Facebook", data: "FACEBOOK" },
	{ label: "Instagram", data: "INSTAGRAM" },
	{ label: "Twitter", data: "TWITTER" },
	{ label: "Rádio", data: "RADIO" },
	{ label: "Placa", data: "PLACA" },
	{ label: "Ligação Direta", data: "LIGACAO_DIRETA" },
	{ label: "Telão", data: "TELAO" },
	{ label: "Google", data: "GOOGLE" },
	{ label: "Viva Real", data: "VIVA_REAL" },
	{ label: "Zap", data: "ZAP" },
	{ label: "OLX", data: "OLX" },
	{ label: "Outros", data: "OUTRO" }
];

export const TIPO_VISTORIA = [
	{ label: "Entrada", data: "ENTRADA" },
	{ label: "Entrada - Complemento", data: "ENTRADA_COMPLEMENTO" },
	{ label: "Saída", data: "SAIDA" },
	{ label: "Saída - Complemento", data: "SAIDA_COMPLEMENTO" }
];

export const STATUS_VISTORIA = [
  { label: "Agendada", data: "AGENDADO" },
  { label: "Concluída", data: "CONCLUIDO" },
  { label: "Cancelada", data: "CANCELADO" },
];

export const ESTADO_VISTORIA = [
	{ label: "Novo", data: "NOVO" },
	{ label: "Bom", data: "BOM" },
	{ label: "Regular", data: "REGULAR" },
	{ label: "Ruim", data: "RUIM" }
];

export const STATUS_RECIBO_REPASSE = [
    { label: "Pago", data: "PAGO" },
    { label: "Em Aberto", data: "EM_ABERTO" },
    { label: "Cancelado", data: "CANCELADO_INATIVACAO" }
]

export const PERFIL_CLIENTE_ITEM_RECIBO = [
	{ label: "Proprietário", data: "PROPRIETARIO" },
	{ label: "Locatário", data: "LOCATARIO" }
]

export const TIPO_ITEM_RECIBO = [
    { label: "Débito", data: "DEBITO" },
    { label: "Crédito", data: "CREDITO" }
]

export const FORMA_RECEBIMENTO = [
    { label: "Caixa da Imobiliária", data: "CAIXA_DA_IMOBILIARIA" },
	{ label: "Transferência Bancária", data: "TRANSFERENCIA_BANCARIA" },
	{ label: "Boleto", data: "BOLETO" },
	{ label: "Cartão de Crédito", data: "CARTAO_DE_CREDITO" },
	{ label: "Acordo", data: "ACORDO" }
]

export const FORMA_PAGAMENTO = [
	{ label: "Pago na Imobiliária", data: "RECEBIMENTO_IMOBILIARIA" },
	{ label: "Depósito em Conta", data: "DEPOSITO_EM_CONTA" }
]

export const STATUS_CAIXA = [
	{ label: "Aberto", data: "ABERTO" },
	{ label: "Fechado", data: "FECHADO" }
]

export const FORMA_PAGAMENTO_LANCAMENTO_CAIXA = [
	{ label: "Cheque", data: "CHEQUE" },
	{ label: "Dinheiro", data: "DINHEIRO" }
]

export const DETALHES_PAGAMENTO_LANCAMENTO_CAIXA = [
	{ label: "Dinheiro", data: "DINHEIRO" },
	{ label: "Cheque", data: "CHEQUE" },
	{ label: "Cheques", data: "CHEQUES" }
]

export const FORMA_ALUGUEL = [
	{ label: "Aluguel Vencido - 1º Vencimento 30 dias após o início", data: "VENCIDO_30_DIAS" },
	{ label: "Aluguel Adiantado - 1º Vencimento no dia do início", data: "ADIANTADO" },
	{ label: "Aluguel Proporcional - Proporcional até o fim do primeiro mês", data: "PROPORCIONAL" },
	//{ label: "", data: "VENCIDO_ULTIMO_DIA" }
];

export const INDICE_REAJUSTE = [
	{ label: "IGPM/FGV", data: "IGPM_FGV" },
	{ label: "IPC/FIPE", data: "IPC_FIPE" },
	{ label: "INPC/IBGE", data: "INPC_IBGE" },
	{ label: "IGP/FGV", data: "IGP_FGV" },
	{ label: "IPC/FGV", data: "IPC_FGV" },
	{ label: "IPCA", data: "IPCA" },
];

export const REGRA_REPASSE = [
	{ label: "Dia fixo a cada mês", data: "DIA_FIXO" },
	{ label: "Dias após o vencimento", data: "DIAS_CORRIDOS" }
];

export const STATUS_IMOVEL = [
	{ label: "Disponível", data: "DISPONIVEL" },
	{ label: "Reservado", data: "RESERVADO" },
	{ label: "Indisponível", data: "INDISPONIVEL" },
	{ label: "Locado", data: "LOCADO" },
	{ label: "Em Desocupação", data: "EM_DESOCUPACAO" },
	{ label: "Arquivado", data: "ARQUIVADO" },
	{ label: "Vendido", data: "VENDIDO" }
];

export const NOME_PORTAL = [
	{ label: "Campainha", data: "CAMPAINHA" },
	{ label: "ImovelWeb", data:"IMOVEL_WEB" },
	{ label: "Moving", data: "MOVING" },
	{ label: "OLX", data: "OLX" },
	{ label: "Viva Real", data: "VIVA_REAL" },
	{ label: "Zap", data: "ZAP" }
];

export const PORTAIS_COM_DESTAQUE = [
	"OLX",
	"VIVA_REAL",
	"ZAP"
];

export const QUANTIDADE_QUARTOS_IMOVEL = [
	{ label: "01", data: 1 },
	{ label: "02", data: 2 },
	{ label: "03", data: 3 },
	{ label: "04", data: 4 },
	{ label: "05+", data: 5 }
];

export const QUANTIDADE_SUITES_IMOVEL = [
	{ label: "01", data: 1 },
	{ label: "02", data: 2 },
	{ label: "03", data: 3 },
	{ label: "04", data: 4 },
	{ label: "05+", data: 5 }
];

export const PERFIS_USUARIO_PESQUISA = [
	{ label: "Usuários", data: undefined },
	{ label: "Parceiros", data: "PARCEIRO" }
];

export const PERFIS_USUARIO = [
	{ label: "Administrador", data: "ADMINISTRADOR" },
	{ label: "Gerente", data: "GERENTE" },
	{ label: "Corretor", data: "CORRETOR" },
	{ label: "Secretário", data: "SECRETARIO" },
	{ label: "Parceiro", data: "PARCEIRO" }
];

export const DIAS_DA_SEMANA = [
	{ label: "Segunda-Feira", data: "SEGUNDA" },
	{ label: "Terça-Feira", data: "TERCA" },
	{ label: "Quarta-Feira", data: "QUARTA" },
	{ label: "Quinta-Feira", data: "QUINTA" },
	{ label: "Sexta-Feira", data: "SEXTA" },
	{ label: "Sábado", data: "SABADO" },
	{ label: "Domingo", data: "DOMINGO" }
];

export const FORMA_PAGAMENTO_SEGURO_INCENDIO = [
	{label:"Sem seguro", data:"SEM_SEGURO"},
	{label:"A vista", data:"A_VISTA"},
	{label:"2x", data:"DUAS_VEZES"},
	{label:"3x", data:"TRES_VEZES"},
	{label:"4x", data:"QUATRO_VEZES"},
	{label:"5x", data:"CINCO_VEZES"},
	{label:"6x", data:"SEIS_VEZES"},
	{label:"7x", data:"SETE_VEZES"},
	{label:"8x", data:"OITO_VEZES"},
	{label:"9x", data:"NOVE_VEZES"},
	{label:"10x", data:"DEZ_VEZES"},
	{label:"11x", data:"ONZE_VEZES"},
	{label:"12x", data:"DOZE_VEZES"},
];

export const TIPO_GARANTIA = [
	{label: "Não especificada", data: undefined},
	{label:"Caução", data:"CAUCAO"},
	{label:"Fiador", data:"FIADOR"},
	{label:"Seguro Fiança", data:"SEGURO_FIANCA"},
	{label:"Título de Capitalização", data:"TITULO_CAPITALIZACAO"},
	{label:"Carta Fiança", data:"CARTA_FIANCA"},
];

export const TIPO_GARANTIA_PESQUISA = [
	{ label: "Todos", data: undefined },
	{ label: "Não especificada", data: "NAO_ESPECIFICADA" },
	{ label: "Caução", data: "CAUCAO" },
	{ label: "Fiador", data: "FIADOR" },
	{ label: "Seguro Fiança", data: "SEGURO_FIANCA" },
	{ label: "Título de Capitalização", data: "TITULO_CAPITALIZACAO" },
	{ label: "Carta Fiança", data: "CARTA_FIANCA" },
];

export const FORMA_PAGAMENTO_CONTA_RECEBER_PAGAR = [
	{label:"À Vista", data:"VISTA"},
	{label: "Parcelado", data: "PARCELADO"}
];

export const TIPO_GRUPO = [
	{label:"Despesa", data:"DESPESA"},
	{label:"Receita", data:"RECEITA"}
];

export const TIPOS_FORMULARIO = [
	{ label: "Aluguel", data: "ALUGUEL" },
	{ label: "Venda", data: "VENDA" },
	{ label: "Imóvel de Venda", data: "IMOVEL_VENDA" },
	{ label: "Imóvel de Aluguel", data: "IMOVEL_ALUGUEL" }
];

export const CANAIS_COBRANCAS = [
	{ label: "Email", data: "EMAIL" },
	{ label: "SMS", data: "SMS" },
	{ label: "Carta de cobrança", data: "CARTA_DE_COBRANCA" },
	{ label: "Ligação", data: "LIGACAO" },
	{ label: "WhatsApp", data: "WHATSAPP" },
	{ label: "Outros", data: "OUTROS" }
]

export const TIPOS_COBRANCAS = [
	{ label: "Cobrança Manual", data: "COBRANCA_MANUAL" },
	{ label: "Cobranca Automática", data: "COBRANCA_AUTOMATICA" }
]

export const TIPO_COBRANCA_AUTO = [
	{ label: 'Avisos Prévios', data: 'AVISO_PREVIO' },
	{ label: 'Avisos após Vencimento', data: 'AVISO_APOS_VENCIMENTO' }
]

export const TIPO_DOCUMENTO_CONTA = [
	{ label: 'Recibo', data: 'RECIBO' },
	{ label: 'Contrato', data: 'CONTRATO' },
	{ label: 'Cupom Fiscal', data: 'CUPOM_FISCAL' },
	{ label: 'NF-e', data: 'NF_E'},
	{ label: 'NFS-e', data: 'NFS_E' }
]

export const TIPO_BOLETO = [
	{ label: 'Boleto Avulso', data: 'OUTROS' },
	{ label: 'Boleto de Acordo', data: 'ACORDO' }
]

export const TIPO_BOLETO_REMESSA = [
	{ label: 'Todos', data: 'TODOS' },
	{ label: 'Boleto Avulso', data: 'BOLETO_AVULSO' },
	{ label: 'Boleto de Acordo', data: 'BOLETO_ACORDO' },
	{ label: 'Boleto de Aluguel', data: 'BOLETO_ALUGUEL' },
]

export const HORA_DO_DIA = [
	{ label: '07:00', data: 7 },
	{ label: '08:00', data: 8 },
	{ label: '09:00', data: 9 },
	{ label: '10:00', data: 10 },
	{ label: '11:00', data: 11 },
	{ label: '12:00', data: 12 },
	{ label: '13:00', data: 13 },
	{ label: '14:00', data: 14 },
	{ label: '15:00', data: 15 },
	{ label: '16:00', data: 16 },
	{ label: '17:00', data: 17 },
	{ label: '18:00', data: 18 },
]

export const EMAIL_REGEX = /^\w+([--_]?\w+)*@\w+([.-]?\w+)*$/;

export const TAMANHO_MAXIMO_LOGO_IMOBILIARIA_EM_BYTES = 1572864;

export const TAMANHO_MAXIMO_IMAGEM_EMAIL_ANIVERSARIO_EM_BYTES = 1572864;

export const TAMANHO_MAXIMO_LOGO_SITE_EM_BYTES = 1572864;

export const TAMANHO_MAXIMO_ARQUIVO_EM_BYTES = 4194304;

export const TAMANHO_MAXIMO_FORMULARIO_EM_BYTES = 4194304;

export const QUANTIDADE_MAXIMA_REPETICAO_BOLETO = 11;